module.exports = __webpack_public_path__ + "img/ebay.b0db15ba.png";